import { Image, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Sidebar from './AnimatedList';
import "./Services.css";
import "./ServicePage.css";
import Banner from "../Img/Services Banner/Services Banner.jpg";

function GlobalForwarding() {
  return (
    <>
      <Image className="fade-in responsive-img" src={Banner} height={500} width="100%" fluid />

      <div className="service-page">
        {/* Hero */}
        <section className="service-hero">
          <span className="service-hero__eyebrow">Our Services</span>
          <h1 className="service-hero__title">
            Ocean <span>Freight</span>
          </h1>
          <p className="service-hero__subtitle">
            Reliable, integrated door-to-door FCL and LCL ocean freight solutions —
            connecting India to every major port worldwide through trusted carriers
            and agents.
          </p>
        </section>

        {/* Content + Sidebar */}
        <div className="service-layout">
          <article className="service-content">
            <h2>Full Container Load (FCL) Services</h2>
            <p>
              <strong>MMOPL</strong> provides reliable, integrated door-to-door FCL (Full Container Load)
              and LCL (Less than Container Load) ocean freight services. We operate weekly services with
              many ocean carriers, covering hundreds of point-pairs all over the world. With a strong
              network of carriers and agents, our clients receive the best transportation rates and
              sailing opportunities. Our subject matter experts, situated in both major and smaller global
              ports, handle everything connected with your cargoes — from booking, documentation and
              customs to final delivery.
            </p>

            <h2>Tailor-Made Modal for FCL Services</h2>
            <ul className="service-features">
              <li>A standard, low-cost base ideal for foreseeable shipments.</li>
              <li>A more dynamic option that is adaptable in accordance with the laws of the marketplace.</li>
              <li>A tailor-made offer, developed together and tailored to your requirements.</li>
            </ul>

            <h2>Less Than Container Load (LCL)</h2>
            <p>
              The Less-than Container Load (LCL) service from MMOPL offers cost-effective solutions
              which are very less expensive than air freight. We operate direct services based on the
              shortest transit time and offer Door to Door solutions — connecting beyond the Container
              Freight Station (CFS) thanks to our extensive ground transportation network.
            </p>

            <div className="service-info-banner">
              <div className="service-info-banner__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                </svg>
              </div>
              <p>
                <strong>Door-to-door worldwide:</strong> From factory pickup to final delivery at your
                warehouse — MMOPL coordinates every leg of the journey.
              </p>
            </div>

            <div className="service-cta">
              <h3>Need a Freight Quote?</h3>
              <p>
                Share your cargo details, origin and destination — we'll respond with a competitive
                ocean freight quote within 24 hours.
              </p>
              <Link to="/Contact" className="service-cta__btn">
                Get a Quote
              </Link>
            </div>
          </article>

          <Sidebar />
        </div>
      </div>
    </>
  );
}

export default GlobalForwarding;